import { Component, Input } from '@angular/core';

import { amostra, isAmostraPendente } from '../../config-pedido-tipo-venda-indicador';

@Component({
    selector: 'sgt-config-pedido-tipo-venda-badge-amostra',
    templateUrl: './config-pedido-tipo-venda-badge-amostra.component.html',
    styleUrls: ['./config-pedido-tipo-venda-badge-amostra.component.less']
})
export class ConfigPedidoTipoVendaBadgeAmostraComponent {
    tipo = amostra;

    /** Status da Amostra */
    @Input() statusAmostra: number;
    /** Se o badge deve exibir o tipo de forma abreviada */
    @Input() isAbreviacao = false;

    /** Verifica se é uma amostra pendente */
    isAmostraPendente(): boolean {
        return isAmostraPendente(this.tipo.id, this.statusAmostra);
    }
}
